var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-body',[_c('b-card-title',{attrs:{"title-tag":"h5"}},[_c('router-link',{staticClass:"title-link",attrs:{"to":{ name: 'game', params: { identifier: _vm.identifier } }}},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }